import React from "react";
import * as Mui from "@mui/material";
import { RootState } from "redux/store";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { fetchLeadActivities } from "redux/slice/lead-activities";
import { withMediaQuery, WithMediaQuery } from "component/shared/with-media-query";
import { RecentMonthlyActivity } from "component/page/lead-activity/recent-monthly-stats";
import { User } from "model/user";
import { LeadActivityFilter } from "../lead-activity-filter";
import * as env from "shared/env";

interface Props extends ReturnType<typeof mapStateToProps> {
	user: User;
}

const mapStateToProps = (_state: RootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	fetchLeadActivities
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithMediaQuery {}

class Component extends React.Component<Props> {

	public componentDidMount() {
		this.props.fetchLeadActivities({});
	}

	public render() {
		const { user, mediaQuery } = this.props;
		return (
			<Mui.Grid
				container
				spacing={4}
				direction={mediaQuery ? "column-reverse" : "row"}
				{...{ alignItems: "flex-start" as const, style: { marginTop: 32 } }}
			>
				<Mui.Grid item xs={12} md={6}>
					<LeadActivityFilter />
				</Mui.Grid>
				{user && user.admin &&
					<RecentMonthlyActivity />
				}
			</Mui.Grid>
		);
	}

}

export const LeadActivity = withMediaQuery("(max-width:960px)")(
	connect(mapStateToProps, mapDispatchToProps)(Component)
);
